import { Box, Typography } from "@mui/material";
import { Plans } from "schemas/payments";

import PlanCard from "../PlanCard";
import styles from "./styles";

interface Props {
  canSubscribe: boolean;
  ctaLabel: string;
  subNote: string;
  onSubscribe: (plan: Plans) => void;
}

const PLAN_CARDS = [
  {
    plan: Plans.PRO,
    planName: "Pro Plan",
    blurb: "For creators who pitch often",
    price: "34",
    payTwo: "$68",
    saved: "$34",
    features: [
      "Unlimited pitch emails",
      "Access 750k+ brand contacts",
      "AI-personalized pitch templates",
      "Inbox, campaigns & reply tracking",
    ],
  },
  {
    plan: Plans.VA,
    planName: "AI Virtual Assistant",
    blurb: "Hands-off pitching for busy creators",
    price: "72",
    payTwo: "$144",
    saved: "$72",
    features: [
      "Everything in Pro Plan",
      "Bento pitches brands for you — on autopilot",
      "Done-for-you campaigns & follow-ups",
      "Weekly check-ins from your assistant",
    ],
  },
];

const B2GoPlans = ({ canSubscribe, ctaLabel, subNote, onSubscribe }: Props) => {
  return (
    <Box sx={styles.panel}>
      <Typography sx={styles.heading}>Choose your plan</Typography>
      <Box sx={styles.grid}>
        {PLAN_CARDS.map((card) => (
          <PlanCard
            key={card.plan}
            planName={card.planName}
            blurb={card.blurb}
            price={card.price}
            payTwo={card.payTwo}
            saved={card.saved}
            features={card.features}
            canSubscribe={canSubscribe}
            ctaLabel={ctaLabel}
            subNote={subNote}
            onSubscribe={() => onSubscribe(card.plan)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default B2GoPlans;
